































import { Vue, Component } from 'vue-property-decorator';
import { Swipe, SwipeItem } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import { getBaseInfo } from './api';

Vue.use(Swipe).use(SwipeItem);

@Component
export default class ViewHolder extends Vue {
  slides: string[] = [
    'https://image2.cqcb.com/d/file/topics/activity/2020-08-19/aCiA35sP-1597803484553.jpg',
  ];
  tabbar = [
    {
      id: 1,
      title: '作品展示',
      path: '/2020-find-sy-little-painter/home',
    },
    {
      id: 2,
      title: '点赞排行',
      path: '/2020-find-sy-little-painter/rank',
    },
    {
      id: 3,
      title: '我要报名',
      path: '/2020-find-sy-little-painter/register',
    },
  ];
  activeTab = 0;
  async created() {
    this.activeTab = this.tabbar.findIndex(
      (item: any) => item.path === this.$route.path,
    );
    if (this.activeTab === -1) {
      this.activeTab = 0;
    }
    const retBaseInfo = await getBaseInfo();
    if (retBaseInfo.data.activityId) {
      this.$addPv(retBaseInfo.data.activityId);
    }
    window.userInfoChange = () => {
      location.reload();
    };
    // 设置pv和分享
    const cover =
      'https://image2.cqcb.com/d/file/topics/activity/2020-08-27/lk1ixzGG-1598513772461.png';
    this.$appShareInfo({
      title: '寻找上游小画家',
      url: location.href,
      subtitle: '上游新闻-寻找上游小画家',
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '寻找上游小画家',
        subtitle: '上游新闻-寻找上游小画家',
        image: cover,
      });
    }
  }
  onTabChange(tabItem: any, index: number) {
    if (tabItem.path === this.$route.path) {
      return;
    }
    this.activeTab = index;
    this.$router.push(tabItem.path);
  }
}
